<div class="wrapper">
  <div class="container">
    <div class="section">
      <div class="page-header">
        <h2 class="heading">プライバシー設定</h2>
        <a
          class="help-link"
          target="_blank"
          href="https://storage.googleapis.com/xp-gpt-prod-public-contents/help/privacy_setting.pdf"
          >公開範囲の詳細について <mat-icon svgIcon="arrow-right"></mat-icon
        ></a>
      </div>
      <ul class="privacy-options">
        @for (option of privacySettingOptions; track option) {
          <li>
            <button
              class="privacy-option"
              [class.active]="option.type === selectedPrivacySetting"
              (click)="onPrivacySettingChange(option.type)"
            >
              <mat-icon
                [svgIcon]="
                  option.type === selectedPrivacySetting
                    ? 'radio-checked'
                    : 'radio-unchecked'
                "
              ></mat-icon>
              <div class="privacy-caption">
                <div class="privacy-title">{{ option.title }}</div>
                <div class="privacy-description">{{ option.description }}</div>
              </div>
            </button>
          </li>
        }
      </ul>
    </div>
    <div class="section">
      <div class="page-header">
        <h2 class="heading">二要素認証</h2>
      </div>
      <div class="checkbox-wrapper">
        <mat-checkbox
          class="mfa-checkbox"
          [checked]="requiredMfa"
          (change)="onMfaChange($event)"
          >二要素認証を必須にする</mat-checkbox
        >
        <div class="caption">
          <p>
            必須にすると、全てのユーザーは次回ログイン時に二要素認証の登録を求められます。
          </p>
          <p>
            任意の場合も、ユーザー自身がセキュリティ設定画面から登録できます。登録済みの設定は任意に戻しても消えません。
          </p>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="page-header">
        <h2 class="heading">IP制限</h2>
      </div>
      <div class="ip-list-wrapper">
        <label for="ip-list" class="ip-list-label"
          >許可するIPアドレス（CIDR形式、改行区切り）</label
        >
        <textarea
          id="ip-list"
          name="ip-list"
          placeholder="例：192.168.0.0/24"
          [(ngModel)]="this.allowedIPAddressesText"
        ></textarea>

        <div class="ip-save-button-wrapper">
          <button rectangle (click)="saveIpAddressControl()">
            IP制限を適用
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
